// extracted by mini-css-extract-plugin
export default {"burgerContainer":"BurgerMenu_burgerContainer__JT6Xd","burgerLine":"BurgerMenu_burgerLine__zY1oo","content":"BurgerMenu_content__Lhxlk","contentOpen":"BurgerMenu_contentOpen__4ovp6"};